import MatomoOptions from '~/models/Matomo/MatomoOptions'

export function useMatomoViewportTrack(htmlEl: HTMLElement | null, options: MatomoOptions) {
    if (htmlEl === null) {
        return
    }

    if (!window._paq) {
        return
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting }) => {
            if (isIntersecting) {
                window._paq.push(['trackEvent', options.category, options.action, options.name, options.value])
                observer.disconnect()
            }
        })
    })

    observer.observe(htmlEl)
}

export function useMatomoClickTrack(htmlEl: HTMLElement | null, options: MatomoOptions) {
    if (htmlEl == null) {
        return
    }

    if (!window._paq) {
        return
    }

    htmlEl.addEventListener('click', () => {
        window._paq.push(['trackEvent', options.category, options.action, options.name, options.value])
    })
}

export function useMatomoSetCustomUrl() {
    if (!window._paq) {
        return
    }

    const route = useRoute()

    watch(
        () => route.fullPath,
        () => {
            setTimeout(() => {
                window._paq.push(['setCustomUrl', route.fullPath])
            }, 0)
        }
    )
}
